module.exports = advancedAds.utils;